import React from "react";
import { Redirect } from "react-router-dom";
import MultiSnack from "./MultiSnack";
import Dialog from "@material-ui/core/Dialog";
import CircularProgress from "@material-ui/core/CircularProgress";

class Notifications extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      showSpinner: false,
      message: null,
      goto: null,
      variant: null,
    };
    this.multiSnackRef = React.createRef();
    this.props.notifier.on("goto", this.redirect);
    this.props.notifier.on("clear", this.clearMessages);
    this.props.notifier.on("error", text => this.setMessage("error", text));
    this.props.notifier.on("error-req", text => this.setMessage("error-req", text));
    this.props.notifier.on("error-resp", text => this.setMessage("error-resp", text));
    this.props.notifier.on("ajax-start", this.showSpinner);
    this.props.notifier.on("ajax-end", this.hideSpinner);
    this.props.notifier.on("success", text => this.setMessage("success", text));
    this.props.notifier.on("none", text => this.setMessage("none", text));
    this.props.notifier.on("cache-loading", this.showSpinner);
    this.props.notifier.on("cache-ready", this.hideSpinner);
    this.props.notifier.on("warning", text => this.setMessage("warning", text));
  }

  showSpinner = () => {
    clearTimeout(this.timeoutHandler);
    this.timeoutHandler = setTimeout(
      () =>
        this.setState({
          showSpinner: true,
          message: null,
          goto: null
        }),
      50
    );
  };

  hideSpinner = () => {
    clearTimeout(this.timeoutHandler);
    this.timeoutHandler = setTimeout(
      () =>
        this.setState({
          showSpinner: false,
          message: null,
          goto: null
        }),
      50
    );
  };

  redirect = route => {
    this.setState({ goto: route, message: null, showSpinner: false });
  };

  setMessage = (type, text) => {
    this.setState({
      message: { type, text }
    });
  };

  clearMessages = () => {
    this.setState({ message: null });
    if (this.multiSnackRef.current) {
      this.multiSnackRef.current.clearQueue();
    }
  };

  render() {
    const redirectTo = {
      pathname: this.state.goto,
      state: { isInternalRedirect: true }
    };

    let result;
    if (this.state.goto) {
      result = <Redirect to={redirectTo} push={true} />;
    } else {
      result = (
        <React.Fragment>
          <Dialog
            open={this.state.showSpinner}
            PaperProps={{
              style: {
                backgroundColor: "transparent",
                boxShadow: "none",
                overflow: "hidden"
              }
            }}
          >
            <div>
              <CircularProgress size={100} disableShrink />
            </div>
          </Dialog>
          <MultiSnack ref={this.multiSnackRef} message={this.state.message} />
        </React.Fragment>
      );
    }
    return result;
  }
}

export default Notifications;
